import { inject, Injectable } from '@angular/core';
import { ProductPricesStore } from '@kinet-open-network/client/product-prices/data-access';
import {
  setError,
  setLoaded,
  setLoading,
} from '@kinet-open-network/client/shared/data-access/state';
import { ApiQuery } from '@kinet-open-network/shared/data-access/api';
import { patchState } from '@ngrx/signals';
import { AppProductPricesService } from '../services/app-product-prices.service';

@Injectable({
  providedIn: 'root',
})
export class AppProductPricesStore extends ProductPricesStore {
  protected override service = inject(AppProductPricesService);

  async exportForOnix(
    query?: ApiQuery | null,
    filename?: string | ((query?: ApiQuery | null) => string),
  ) {
    const effectiveQuery = query ?? this.query();
    patchState(this, setLoading());

    try {
      await this.service.exportForOnix(
        effectiveQuery,
        typeof filename === 'function' ? filename(effectiveQuery) : filename,
      );
      patchState(this, setLoaded());
    } catch (error) {
      patchState(this, setError(error));
    }
  }
}
